import { InternalApiRateLimitBucket } from '../../api-internal';
import { v4 as uuidv4 } from 'uuid';
import { RateLimitBucket } from './RateLimiterConfig';

export const internalRateLimitBucketToRateLimitBucket = (bucket: InternalApiRateLimitBucket): RateLimitBucket => {
  return {
    ...bucket,
    id: uuidv4(),
  };
};
